export default __webpack_public_path__ + "static/media/H_Underlay.c6e772df.jpg";